var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpNarrow = function SvgArrowUpNarrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 11 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m10.157 4.293-4-4a1 1 0 0 0-.073-.066L6.048.2 6.005.168Q5.984.154 5.961.142q-.02-.013-.04-.024L5.876.096l-.043-.02L5.788.06 5.74.043 5.695.031 5.645.02 5.592.011 5.55.005a1 1 0 0 0-.198 0Q5.33.007 5.307.01L5.255.02l-.05.012-.045.012-.048.017-.045.016-.043.02-.045.022q-.02.011-.04.024l-.044.026L4.852.2l-.036.027a1 1 0 0 0-.073.065l-4 4a1 1 0 0 0 1.414 1.415L4.45 3.414V15a1 1 0 1 0 2 0V3.414l2.293 2.293a1 1 0 0 0 1.414-1.414",
    clipRule: "evenodd"
  })));
};
export default SvgArrowUpNarrow;